/**
 * The light tickets sheet's palette: the Select tickets sheet's
 * (EngineTicketsSheet) and Link in Bio's tickets sheet's
 * (`TICKETS_SHEET_COLORS`), so the checkout reads as the same sheet.
 */
export const colors = {
  text: "#1d1d1f",
  secondary: "#6e6e73",
  surface: "#ffffff",
  fill: "#f5f5f7",
  border: "#e5e5ea",
  primary: "#0082ec",
  onPrimary: "#ffffff",
  success: "#34c759",
  /** "You're going" as text on white: the tick's green, deepened. */
  successText: "#248a3d",
  danger: "#d70015",
  dangerFill: "rgba(215, 0, 21, 0.08)",
} as const;

/** The island's look: the tickets sheet's appearance for the drop-in
 *  (`TICKETS_SHEET_CHECKOUT_APPEARANCE`), read by the island's page. */
export { TICKETS_SHEET_CHECKOUT_APPEARANCE as ISLAND_APPEARANCE } from "@libs/shared-ui";

/** The primary button's height and radius, the sheet's own. */
export const CONTROL_HEIGHT = 48;
export const RADIUS = 12;
